import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getRecordList = async (params: object) => {
  return await POST({ url: Api.getRecordList, data: params, showError: false })
}
